// aiAssistantUtils.js
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const port = window.location.port ? `:${window.location.port}` : '';
const serverUrl = isLocalhost ? `http://localhost${port}` : 'https://webassistant.live';

console.log('Server URL:>>>>', serverUrl, window.location.hostname, window.location.port);


//import * as ort from 'onnxruntime-web';

export function getServerUrl() {
    return serverUrl;
} 

export function render(t) {
    return `
        <style>
            :host {
                display: block;
                width: 100%;
                height: 100%;
                z-index: 1000;
            }
            #assistant-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 20%;
                height: 40%;
                position: fixed;
                bottom: 0;
                right: 0;
                z-index:1000 !important;
            }
 
            #transcript-container {
                display: none; /* Hide the transcript on the main page */
            }
            #email-form {
                display: none;
                flex-direction: column;
                align-items: center;
            }
            #disable-assistant {
                position: absolute;
                bottom: 20px;
                right: 150px;
                width: 50px;
                height: 50px;
                background: none;
                border: none;
                cursor: pointer;
            }
            #show-transcript {
                position: absolute;
                bottom: 15px;
                right: 75px;
                width: 35px;
                height: 35px;
                background: none;
                border: none;
                cursor: pointer;
            }
            #three-container {
                position: fixed;
                bottom: 100px;
                right:10px;
                width: 40%;
                height: 40%;
                justify-content: center;
                align-items: center;
                /* visibility: hidden; */
            }
            
            .tree-extra {
                background-color: rgba(0, 0, 0, 0.7);
                z-index: 1000 !important;
            }

            #disable-assistant-img, #show-transcript-img {
                background: none;
                border: none;
                color: white;
                width: 100%;
                height: 100%;
               
            }
            #show-transcript-img { 
                background: #ccc;
            }


            #transcript-modal {
                position: fixed;
                bottom: 100px;
                right:10px;
                width: 50%;
                height: 80%;
                background-color: rgba(0, 0, 0, 0.7);
                z-index: 1000 !important;
                display: none;
                justify-content: center;
                align-items: center;
                display:none;
            }

            #transcript-modal-content {
                    background-color: #1e1e1e;
                    color: white;
                    border-radius: 5px;
                    width: 90%;
                    height: 90%;
                    display: flex;
                    flex-direction: column;
                    
                }
            .close-button, .expand-button {
                position: absolute;
                top: 0;
                right: 0;
                font-size: 30px;
                cursor: pointer;
                color: white;
            }
            .expand-button{
                right: 30px;
            }

            #modal-transcript-container {
                flex-grow: 1;
                overflow-y: auto;
                padding: 20px;
            }           

            .transcript-message {
                display: flex;
                flex-direction: column;
                margin-bottom: 15px;
            }
            .transcript-message.user {
                align-items: flex-end;
                
                padding: 10px;
                border-radius: 5px;
                color:aqua;
            }
            .transcript-message.ai {
                align-items: flex-start;
            }
            
            .transcript-message.user .content {
                background-color: transparent;
            }
            .transcript-message.ai .content {
                background-color: #2b2b2b;
            }

            .hidden {
                display: none;
            }
  
            #message-input-container {
                display: flex;
                padding: 10px;
            }

            #message-input {
                    flex-grow: 1;
                    padding: 5px;
                    border: 1px solid #ccc;
                    border-radius: 3px;
                }
            #send-message {
                    margin-left: 5px;
                    padding: 5px 10px;
                    background-color: gray;
                    color: white;
                    border: none;
                    border-radius: 3px;
                    cursor: pointer;
                }

            
            .transcript-message {
                margin-bottom: 10px;
            }

            .transcript-message .content {
                margin-bottom: 5px;
                background-color: #2b2b2b;
            }
   
            .transcript-message .timestamp {
                font-size: 0.8em;
                color: #a0a0a0;
                margin-top: 3px;
                padding: 10px;
            }
            .typing-image {
                width: 80px;
                height: 20px;
            }
           .context-toggle {
                cursor: pointer;
                background: none;
                border: none;
                color: aqua;
                margin-left: 10px;
                font-size: 8px;
                font-style: italic;
            }

            .context {
                margin-top: 10px;
                padding: 10px;
                background-color: transparent;
                border-radius: 4px;
                font-size: 0.7em;
                font-style: italic;
            }
            .transcript-message .content {
                margin-bottom: 5px;
            }

            #powered-by {
                position: absolute;
                bottom: 5px;
                left: 5px;
                font-size: 12px;
                color: aqua;
                display: flex;
                align-items: center;
                background-color: rgba(0, 0, 0, 0.1);
                padding: 2px 5px;
                border-radius: 3px;
                cursor: pointer;
            }
            #powered-by img {
                max-width: 20px;
                margin-right: 5px;
            }
   
        </style>

           <div id="assistant-container">
                <div id="transcript-container"></div>
                <button id="disable-assistant" class="icon-button">
                    <img id="disable-assistant-img" src="${serverUrl}/public/img/on.png" alt="Speaking on / off status" />
                </button>
                <button id="show-transcript" class="icon-button">
                    <img id="show-transcript-img" src="${serverUrl}/public/img/transcript.png" alt="Show transcript" />
                </button>
                <div id="email-form">
                    <input type="email" id="user-email" placeholder="${t('Email address')}">
                    <button id="send-transcript">Gönder</button>
                </div>
                <div id="three-container">
                    <!--span id="expand-three" class="expand-button">⧠</span-->
                    <span id="close-three" class="close-button">&times;</span>
                </div>
            </div>
            <div id="transcript-modal">
                <span id="expand-modal" class="expand-button">⧠</span>
                <span id="close-modal" class="close-button">&times;</span>
                <div id="transcript-modal-content">
                    <div id="modal-transcript-container"></div>
                    <img id="typing-image" class="typing-image" style="display:none;" src="${serverUrl}/public/img/typing-message.gif" alt="Typing imagination image" />
                    <div id="message-input-container">
                        <input type="text" id="message-input" placeholder="${t('Ask your question about the site...')}" >
                        <button id="send-message">Send</button>
                    </div>
                </div>
                <div id="powered-by">
                    <img src="${serverUrl}/public/img/favicon.png" alt="Favicon">
                    <span>Powered by WebAssistant</span>
                </div>
                
            </div>
            

    `;
}

export function float32ArrayToWavBlob(float32Array) {
    const buffer = new ArrayBuffer(44 + float32Array.length * 2);
    const view = new DataView(buffer);

    const writeString = (view, offset, string) => {
        for (let i = 0; i < string.length; i++) {
            view.setUint8(offset + i, string.charCodeAt(i));
        }
    };

    const floatTo16BitPCM = (output, offset, input) => {
        for (let i = 0; i < input.length; i++, offset += 2) {
            const s = Math.max(-1, Math.min(1, input[i]));
            output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    };

    writeString(view, 0, 'RIFF');
    view.setUint32(4, 32 + float32Array.length * 2, true);
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, 16000, true);
    view.setUint32(28, 16000 * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeString(view, 36, 'data');
    view.setUint32(40, float32Array.length * 2, true);
    floatTo16BitPCM(view, 44, float32Array);

    return new Blob([view], { type: 'audio/wav' });
}
export function logState(message) {
    console.log(`[${new Date().toISOString()}] ${message}`);
}
export function logError(message, error) {
    console.error(`[${new Date().toISOString()}] ${message}`, error);
}

export function  displayError(message) {
    const errorElement = document.createElement('div');
    errorElement.textContent = message;
    errorElement.style.position = 'absolute';
    errorElement.style.color = 'white';
    errorElement.style.backgroundColor = 'red';
    errorElement.style.bottom = '0';
    errorElement.style.width = '100%';
    errorElement.style.height = '30px';
    errorElement.style.fontSize = '16px';
    errorElement.style.display = 'flex';
    errorElement.style.justifyContent = 'center';
    errorElement.style.alignItems = 'center';
    errorElement.style.zIndex = 1000;
    this.shadowRoot.getElementById('assistant-container').appendChild(errorElement);

    setTimeout(() => {
        errorElement.remove();
    }, 1000);
}
